import script from "./wordpress-site-snapshots.vue?vue&type=script&setup=true&lang=js"
export * from "./wordpress-site-snapshots.vue?vue&type=script&setup=true&lang=js"

import "./wordpress-site-snapshots.vue?vue&type=style&index=0&id=64cb0816&lang=scss"

const __exports__ = script;

export default __exports__